<div class="content-wrapper">
  <div class="page-title-box d-flex align-items-center justify-content-between">
    <h4 class="page-title">
      {{ tipoImportacion === 'FARMACIAS' ? 'Importar Farmacias (Módulo Signo Médicos)' : 'Importar Padrón' }}
    </h4>
    <button mat-icon-button color="primary"
            matTooltip="¿Cómo funciona la importación?"
            (click)="openHelpDialog()"
            class="help-button hvr-grow">
      <mat-icon>help_outline</mat-icon>
    </button>
  </div>

  <mat-card>
    <mat-horizontal-stepper #stepper [linear]="true" class="wizard-stepper">

      <!--====================================
          PASO 0: SELECTOR DE TIPO
          ======================================-->
      <mat-step>
        <ng-template matStepLabel>Tipo de Importación</ng-template>

        <div class="selection-container mt-4 mb-5">
          <h5 class="text-center mb-4">¿Qué desea importar hoy?</h5>

          <div class="row">
            <div class="col-md-4 mb-4">
              <mat-card class="selection-card hvr-glow h-100" (click)="setTipoImportacion('PADRON_MDP')" [class.selected]="tipoImportacion === 'PADRON_MDP'">
                <div class="card-content text-center p-4">
                  <i class="fas fa-hospital-symbol fa-4x mb-3 text-primary"></i>
                  <h5>Importar Padrón Mar del Plata</h5>
                  <p class="text-muted">Flujo para carga de especialistas desde archivos PDF.</p>
                </div>
              </mat-card>
            </div>

            <div class="col-md-4 mb-4">
              <mat-card class="selection-card hvr-glow h-100" (click)="setTipoImportacion('FARMACIAS')" [class.selected]="tipoImportacion === 'FARMACIAS'">
                <div class="card-content text-center p-4">
                  <i class="fas fa-pills fa-4x mb-3 text-success"></i>
                  <h5>Importar Farmacias</h5>
                  <p class="text-muted">Carga masiva de farmacias desde archivos Excel (.xlsx, .xls).</p>
                </div>
              </mat-card>
            </div>
            <div class="col-md-4 mb-4">
              <a routerLink="/padrones/importar-hipocrates" class="text-decoration-none d-block h-100">
                <mat-card class="selection-card hvr-glow h-100">
                  <div class="card-content text-center p-4">
                    <i class="fas fa-hospital fa-4x mb-3 text-primary"></i>
                    <h5>Importar Centros Hipócrates</h5>
                    <p class="text-muted">Centros y especialidades desde el padrón Excel Hipócrates.</p>
                  </div>
                </mat-card>
              </a>
            </div>
            <div class="col-md-4 mb-4">
              <a routerLink="/padrones/importar-compania-farmaceutica" class="text-decoration-none d-block h-100">
                <mat-card class="selection-card hvr-glow h-100">
                  <div class="card-content text-center p-4">
                    <i class="fas fa-prescription-bottle fa-4x mb-3 text-primary"></i>
                    <h5>Importar Centros Compañía Farmacéutica</h5>
                    <p class="text-muted">Centros y localidades desde el padrón Excel de Compañía Farmacéutica.</p>
                  </div>
                </mat-card>
              </a>
            </div>
          </div>
        </div>
      </mat-step>

      <!--====================================
          FLUJO PADRÓN MAR DEL PLATA (INTACTO)
          ======================================-->
      <mat-step [stepControl]="step1Form" *ngIf="tipoImportacion === 'PADRON_MDP'">
          <form [formGroup]="step1Form">
            <ng-template matStepLabel>Subir Padrón</ng-template>

            <div class="form-row mt-3">
                <div class="col-md-6 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Gerenciadora</mat-label>
                      <mat-select formControlName="signoGerenciadoraId">
                        <mat-option *ngFor="let gar of gerenciadoras" [value]="gar._id">
                          {{gar.nombre}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-md-6 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Zona</mat-label>
                      <mat-select formControlName="signoZonaId">
                        <mat-option *ngFor="let gar of zonas" [value]="gar._id">
                          {{gar.concepto}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-md-12 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Localidad (Escriba para buscar)</mat-label>
                      <mat-select formControlName="signoLocalidadId">
                          <div class="p-2 sticky-top bg-white border-bottom">
                              <input type="text"
                                     class="form-control form-control-sm"
                                     placeholder="Filtrar por nombre..."
                                     (input)="onLocalidadSearch($event)"
                                     (keydown)="$event.stopPropagation()">
                          </div>
                          <mat-option *ngFor="let loc of localidadesFiltradas" [value]="loc._id">
                              {{loc.nombre}} <small class="text-muted" *ngIf="loc.provincia">- {{loc.provincia.nombre}}</small>
                          </mat-option>
                          <mat-option *ngIf="localidadesFiltradas.length === 0" disabled>
                              No se encontraron resultados
                          </mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>

                <!-- Código de área (teléfonos) -->
                <div class="col-md-12 mb-3">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Código de área (teléfonos)</mat-label>
                    <input matInput formControlName="codigoArea" placeholder="Ej: Mar del Plata (Buenos Aires) → 0223" autocomplete="off">
                    <mat-hint>Si el teléfono ya tiene código de área, se ignorará este valor.</mat-hint>
                  </mat-form-field>
                </div>

                <div class="col-md-12 mb-3">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Planes Asociados</mat-label>
                    <mat-select formControlName="planesIds" multiple>
                      <mat-option *ngFor="let plan of planes" [value]="plan._id">
                        {{plan.identificacion}} - {{plan.denominacion}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-12 mb-3">
                  <div class="alert alert-warning border-warning text-dark shadow-sm p-3 mb-2" style="font-size: 0.85rem; border-left: 5px solid #ffc107; background-color: #fff3cd;">
                    <i class="fas fa-exclamation-triangle text-warning mr-2 fa-lg"></i>
                    <strong>¡Atención antes de importar!</strong> Si este padrón ya fue cargado previamente, debe borrar los centros de la gerenciadora seleccionada antes de realizar la nueva importación. De lo contrario, se crearán registros duplicados en el sistema (si esto ocurre, se pueden eliminar tranquilamente y volver a cargar, ya que al borrar se eliminan todos los centros asociados a la gerenciadora seleccionada, incluso si están duplicados).
                  </div>
                </div>

                <div class="col-12 mt-2 mb-3">
                  <label>Archivo Padrón PDF</label>
                  <div class="custom-file mb-3">
                      <input type="file" class="custom-file-input" id="customFile" (change)="onFileSelected($event)" accept="application/pdf">
                      <label class="custom-file-label" for="customFile">{{ selectedFile ? selectedFile.name : 'Seleccionar Archivo' }}</label>
                  </div>
                </div>
            </div>

            <div class="d-flex justify-content-end mt-4">
              <button mat-button matStepperPrevious class="mr-2">Atrás</button>
              <button mat-raised-button color="primary"
                      type="button"
                      [disabled]="step1Form.invalid || !selectedFile || isProcessingPdf"
                      (click)="processPdf()">
                <i class="fas fa-file-import"></i>
                {{ isProcessingPdf ? 'Cargando Padrón...' : 'Siguiente' }}
              </button>
            </div>
          </form>
        </mat-step>

        <!--====================================
            PASO 2: ESPECIALIDADES NO MAPEADAS
            ======================================-->
      <mat-step *ngIf="tipoImportacion === 'PADRON_MDP'">
        <ng-template matStepLabel>Especialidades No Encontradas</ng-template>
          <!-- ... CONTENIDO PASO 2 MDP (SIN CAMBIOS) ... -->

        <div class="mt-3">
            <div class="alert alert-info border-info" *ngIf="unmatchedSpecialties.length > 0">
                <i class="fas fa-info-circle"></i> Se detectaron <strong>{{unmatchedSpecialties.length}}</strong> especialidades nuevas o no encontradas. Debe asignar y guardar cada una para poder avanzar en el proceso del wizard.
            </div>

            <div class="alert alert-success border-success" *ngIf="unmatchedSpecialties.length === 0">
                <i class="fas fa-check-circle"></i> Todas las especialidades están resueltas. Ya puede continuar.
            </div>

            <div class="table-responsive" *ngIf="unmatchedSpecialties.length > 0">
              <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Especialidad en Padrón</th>
                      <th>Registros que la utilizan</th>
                      <th style="min-width:250px;">Mapear a Especialidad del Sistema</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let esp of unmatchedSpecialties">
                      <td class="align-middle"><strong>{{ esp.especialidad }}</strong></td>
                      <td class="align-middle">{{ esp.totalRegistros }}</td>
                       <td class="align-middle">
                          <div class="d-flex flex-column">
                            <mat-form-field appearance="outline" class="w-100 mb-0">
                              <mat-select #especRef placeholder="Vincular con Existente...">
                                <mat-option *ngFor="let cat of catalogoEspecialidades" [value]="cat._id">
                                  {{ cat.concepto }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>

                            <div class="btn-group mt-1">
                              <button mat-flat-button color="accent" class="mr-1"
                                      [disabled]="!especRef.value"
                                      (click)="mapSpecialty(esp, especRef.value)">
                                <i class="fas fa-link"></i> Vincular
                              </button>

                              <button mat-stroked-button color="primary" (click)="createNewSpecialty(esp)">
                                <i class="fas fa-plus"></i> Crear como Nueva
                              </button>
                            </div>
                          </div>
                      </td>
                    </tr>
                  </tbody>
              </table>
            </div>

            <div class="d-flex justify-content-end mt-4">
               <button mat-button matStepperPrevious class="mr-2">Atrás</button>
               <button mat-raised-button color="primary"
                      (click)="nextToGeolocation()"
                      [disabled]="!allSpecialtiesResolved">
                      Procesar Direcciones
               </button>
            </div>
        </div>
      </mat-step>

      <!--====================================
          PASO 3: GEOLOCALIZACIÓN  & CREACIÓN
          ======================================-->
      <mat-step *ngIf="tipoImportacion === 'PADRON_MDP'">
        <ng-template matStepLabel>Geolocalización Y Cierre</ng-template>

        <div class="mt-3">
            <h5 class="mb-3">Centros / Direcciones con errores de mapa</h5>

            <div class="alert alert-warning border-warning" *ngIf="unmatchedAddresses.length > 0">
                <i class="fas fa-exclamation-triangle"></i> No fue posible ubicar geográficamente todas las direcciones en el padrón, pero <strong>esto no impide crear los centros</strong>. Puede continuar.
            </div>

             <div class="alert alert-success border-success" *ngIf="unmatchedAddresses.length === 0 && !isGeolocating">
                <i class="fas fa-check-circle"></i> Todas las direcciones pasadas y creadas se localizaron exitosamente.
             </div>

             <div class="table-responsive" *ngIf="unmatchedAddresses.length > 0" style="max-height: 350px; overflow-y: auto;">
              <table class="table table-bordered table-striped p-0 m-0">
                  <thead class="bg-light">
                    <tr>
                      <th>Dirección No Encontrada</th>
                      <th>Cantidad de Profesionales</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let addr of unmatchedAddresses">
                      <td><span class="text-danger"><i class="fas fa-map-marker-alt"></i></span> {{ addr.domicilio }}</td>
                      <td>{{ addr.totalRegistros }}</td>
                    </tr>
                  </tbody>
              </table>
             </div>

             <hr class="mt-5 mb-4"/>

              <!-- Mensaje Informativo sobre la Agrupación (Consolidación por Domicilio) -->
              <div class="alert alert-info border-info mb-4 shadow-sm" role="alert">
                 <div class="d-flex align-items-center mb-3">
                   <i class="fas fa-info-circle fa-2x mr-3 text-info"></i>
                   <div>
                     <h5 class="alert-heading mb-1 text-info font-weight-bold">Información de Procesamiento y Nomenclatura:</h5>
                     <p class="mb-0 text-dark">
                       El sistema generará <b>un único centro médico por cada código o dirección física</b> detectada.
                       Si varios profesionales atienden en el mismo lugar, se creará una ficha unificada llamada <b class="text-primary">"CONSULTORIOS [Calle] [Altura]"</b> consolidando todas sus especialidades y teléfonos.
                     </p>
                   </div>
                 </div>

                 <!-- Listado de Planes (CORREGIDO property a .denominacion) -->
                 <div class="bg-white p-2 border rounded" *ngIf="planes.length > 0">
                    <p class="mb-1 small font-weight-bold text-muted"><i class="fas fa-layer-group"></i> Planes a vincular en cada centro:</p>
                    <div class="d-flex flex-wrap" *ngIf="getSelectedPlanes().length > 0">
                       <span *ngFor="let p of getSelectedPlanes()" class="badge badge-light border mr-2 mb-1 p-2 text-dark font-weight-bold shadow-sm">
                         <i class="fas fa-check text-success mr-1"></i> {{ p.denominacion }}
                       </span>
                    </div>
                     <div class="small text-danger font-weight-bold p-2" *ngIf="getSelectedPlanes().length === 0">
                        <i class="fas fa-exclamation-triangle mr-1"></i> Ninguno (No se asignarán planes).
                     </div>
                 </div>
              </div>

              <!-- BLOQUE DE UNIFICACIÓN MANUAL (Petición Usuario: Separar procesos) -->
              <div *ngIf="showUnifyButton" class="alert alert-warning mt-3 border-warning shadow-sm animate__animated animate__pulse">
                  <div class="d-flex align-items-center justify-content-between">
                     <div class="d-flex align-items-center">
                        <i class="fas fa-magic fa-2x mr-3 text-warning"></i>
                        <div>
                           <h6 class="mb-1 font-weight-bold text-warning-dark">Importación lista, ¿Quieres optimizar ahora?</h6>
                           <p class="mb-0 small text-dark">
                             Al pulsar el botón, el sistema unificará especialidades en las mismas direcciones y corregirá nombres/alturas inconsistentes.
                           </p>
                        </div>
                     </div>
                     <button class="btn btn-warning btn-lg font-weight-bold ml-3 shadow-sm hvr-grow" (click)="unifyCentersPostProcess(lastGerenciadoraId)">
                        <i class="fas fa-object-group mr-2"></i> Unificar Centros (Post-Proceso)
                     </button>
                  </div>
              </div>
             <hr class="mt-5 mb-4"/>

             <!-- Barra de Progreso para la Creación Final -->
             <div *ngIf="isMigratingData" class="mt-4 animated fadeIn bg-white p-3 border rounded shadow-sm">
                <label class="d-block mb-2 text-primary font-weight-bold">
                  <i class="fas fa-spinner fa-spin mr-2"></i>
                  Creando fichas médicas: <b>{{geoCurrentCount}} / {{geoInitialCount}}</b> ({{geoProgress}}%)
                </label>
                <mat-progress-bar mode="determinate" [value]="geoProgress" color="primary" style="height: 10px; border-radius: 5px;"></mat-progress-bar>
                <div class="mt-2 d-flex justify-content-between align-items-center">
                   <p class="small text-muted mb-0"><i>Procesando registros y validando contra la base de datos real...</i></p>
                   <span class="badge badge-primary p-2">{{geoProgress}}%</span>
                </div>
             </div>
              <div class="d-flex justify-content-end mt-4" *ngIf="!isGeolocating && !isMigratingData">
                 <button mat-button matStepperPrevious class="mr-2" *ngIf="!showUnifyButton">Atrás</button>
                 <button mat-raised-button color="primary"
                         [disabled]="showUnifyButton && !hasUnified"
                         (click)="finishProcess()">
                    {{ showUnifyButton ? 'Ver Resumen y Finalizar' : 'Finalizar y Crear Centros' }}
                 </button>
              </div>

        </div>
      </mat-step>

      <!--====================================
          FLUJO IMPORTAR FARMACIAS
          ======================================-->
      <mat-step [stepControl]="pharmacyForm" *ngIf="tipoImportacion === 'FARMACIAS'">
          <form [formGroup]="pharmacyForm">
            <ng-template matStepLabel>Configurar Importación</ng-template>

            <div class="form-row mt-3">
              <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Gerenciadora</mat-label>
                  <mat-select formControlName="gerenciadoraId">
                    <mat-option *ngFor="let gar of gerenciadoras" [value]="gar._id">
                      {{gar.nombre}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Rubro</mat-label>
                  <mat-select formControlName="rubroId">
                    <mat-option *ngFor="let r of rubros" [value]="r._id">
                      {{r.concepto}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-md-12 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Especialidad</mat-label>
                  <mat-select formControlName="especialidadId">
                    <mat-option *ngFor="let esp of catalogoEspecialidades" [value]="esp._id">
                      {{esp.concepto}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-md-12 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Planes Asociados</mat-label>
                  <mat-select formControlName="planesIds" multiple>
                    <mat-option *ngFor="let plan of planes" [value]="plan._id">
                      {{plan.identificacion}} - {{plan.denominacion}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-12 mb-3">
                <div class="alert alert-warning border-warning text-dark shadow-sm p-3 mb-2" style="font-size: 0.85rem; border-left: 5px solid #ffc107; background-color: #fff3cd;">
                  <i class="fas fa-exclamation-triangle text-warning mr-2 fa-lg"></i>
                  <strong>¡Atención antes de importar!</strong> Si este padrón ya fue cargado previamente, debe borrar los centros de la gerenciadora seleccionada antes de realizar la nueva importación. De lo contrario, se crearán registros duplicados en el sistema (si esto ocurre, se pueden eliminar tranquilamente y volver a cargar, ya que al borrar se eliminan todos los centros asociados a la gerenciadora seleccionada, incluso si están duplicados).
                </div>
              </div>

              <div class="col-12 mb-4">
                <div class="card border-danger shadow-sm" style="background-color: #fff8f8;">
                  <div class="card-body p-3">
                    <div class="row align-items-center">
                      <div class="col-md-8 col-sm-12">
                        <h6 class="text-danger font-weight-bold mb-1">
                          <i class="fas fa-exclamation-triangle mr-1"></i> Zona de Peligro: Limpiar Farmacias
                        </h6>
                        <p class="small text-muted mb-0">
                          <strong>ATENCIÓN:</strong> esta acción eliminará <strong>TODOS</strong> los centros médicos con rubro <strong>FARMACIA</strong> de la base de datos.
                          Esta operación es irreversible y <strong>solo debe ejecutarse una única vez</strong> al inicio del proceso de reemplazo.
                        </p>
                      </div>
                      <div class="col-md-4 col-sm-12 text-center mt-3 mt-md-0 d-flex flex-column align-items-center justify-content-center">
                        <mat-slide-toggle [(ngModel)]="enableDeletePharmacies" [ngModelOptions]="{standalone: true}" color="warn" class="mb-2">
                          <span class="small font-weight-bold text-dark">Habilitar botón</span>
                        </mat-slide-toggle>
                        <button mat-raised-button color="warn"
                                type="button"
                                class="w-100"
                                [disabled]="!enableDeletePharmacies || isDeletingPharmacies || isProcessingPharmacy"
                                (click)="confirmDeletePharmacies()">
                          <i class="fas fa-trash-alt mr-1"></i> ELIMINAR FARMACIAS
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 mt-2 mb-3">
                <label>Archivo Excel de Farmacias (.xlsx, .xls)</label>
                <div class="custom-file mb-3">
                    <input type="file" class="custom-file-input" id="pharmacyFile" (change)="onPharmacyFileSelected($event)" accept=".xlsx, .xls">
                    <label class="custom-file-label" for="pharmacyFile">{{ pharmacyFile ? pharmacyFile.name : 'Seleccionar Archivo Excel' }}</label>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end mt-4">
              <button mat-button matStepperPrevious class="mr-2">Atrás</button>
              <button mat-raised-button color="primary"
                      type="button"
                      [disabled]="pharmacyForm.invalid || !pharmacyFile || isProcessingPharmacy"
                      (click)="processPharmacyExcel()">
                <i class="fas fa-file-upload"></i>
                {{ isProcessingPharmacy ? 'Procesando...' : 'Importar Excel' }}
              </button>
            </div>

            <!-- PROGRESO IMPORTACIÓN EXCEL -->
            <div *ngIf="isProcessingPharmacy" class="mt-3 animated fadeIn">
              <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
              <p class="small text-muted mt-2 text-center">Analizando el archivo Excel y buscando coincidencias en el sistema...</p>
            </div>
          </form>
        </mat-step>

      <!-- NUEVO PASO: PROVINCIAS FALTANTES (FARMACIAS) -->
      <mat-step *ngIf="tipoImportacion === 'FARMACIAS'">
        <ng-template matStepLabel>Análisis de Provincias</ng-template>

        <div class="mt-3">
            <!-- ACORDEON DE DUPLICADOS OMITIDOS -->
            <mat-accordion *ngIf="pharmacyDuplicates.length > 0">
              <mat-expansion-panel class="mb-4" style="border-left: 4px solid #dc3545;">
                <mat-expansion-panel-header class="bg-light">
                  <mat-panel-title class="text-danger font-weight-bold">
                    <i class="fas fa-copy mr-2 mt-1"></i> Se omitieron {{pharmacyDuplicates.length}} farmacias duplicadas
                  </mat-panel-title>
                  <mat-panel-description>
                    Ya existían previamente en el sistema. Clic para ver detalle.
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="table-responsive mt-3" style="max-height: 300px; overflow-y: auto;">
                    <table class="table table-sm table-hover border">
                        <thead class="bg-light sticky-top">
                            <tr>
                                <th class="small py-2 pl-3">Farmacia</th>
                                <th class="small py-2">Domicilio</th>
                                <th class="small py-2 pr-3">Motivo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dup of pharmacyDuplicates">
                                <td class="small pl-3 font-weight-bold text-dark">{{dup.farmacia}}</td>
                                <td class="small">{{dup.domicilio}}</td>
                                <td class="small font-italic text-muted pr-3">{{dup.motivo}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
              </mat-expansion-panel>
            </mat-accordion>

            <h6 class="font-weight-bold mb-3 border-bottom pb-2"><i class="fas fa-map text-primary mr-2"></i> Análisis de Provincias Faltantes</h6>

            <div class="alert alert-info border-info" *ngIf="missingProvinces.length > 0">
                <i class="fas fa-info-circle"></i> Se detectaron <strong>{{missingProvinces.length}}</strong> provincias en el archivo Excel que no existen en el sistema. Debe crearlas para poder continuar.
            </div>

            <div class="alert alert-success border-success" *ngIf="missingProvinces.length === 0">
                <i class="fas fa-check-circle"></i> Todas las provincias del archivo fueron encontradas en el sistema. Ya puede continuar.
            </div>

            <div class="table-responsive" *ngIf="missingProvinces.length > 0">
              <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Provincia en Excel</th>
                      <th style="min-width:150px; text-align: center;">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let prov of missingProvinces">
                      <td class="align-middle"><strong>{{ prov }}</strong></td>
                      <td class="align-middle text-center">
                          <button mat-stroked-button color="primary" (click)="createNewProvince(prov)">
                            <i class="fas fa-plus"></i> Crear / Asociar
                          </button>
                      </td>
                    </tr>
                  </tbody>
              </table>
            </div>

            <div class="d-flex justify-content-end mt-4">
               <button mat-button matStepperPrevious class="mr-2">Atrás</button>
               <button mat-raised-button color="primary"
                      (click)="nextToLocalidadesFarmacias()"
                      [disabled]="!allProvincesResolved">
                      Continuar a Localidades
               </button>
            </div>
        </div>
      </mat-step>

      <!-- NUEVO PASO: LOCALIDADES FALTANTES (FARMACIAS) -->
      <mat-step *ngIf="tipoImportacion === 'FARMACIAS'">
        <ng-template matStepLabel>Análisis de Localidades</ng-template>

        <div class="mt-3">
            <h6 class="font-weight-bold mb-3 border-bottom pb-2"><i class="fas fa-map-marker-alt text-primary mr-2"></i> Análisis de Localidades Faltantes</h6>

            <div class="alert alert-info border-info" *ngIf="missingLocalities.length > 0">
                <i class="fas fa-info-circle"></i> Se detectaron <strong>{{missingLocalities.length}}</strong> localidades en el archivo Excel que no existen en el sistema. Debe crearlas y asignarles una zona para poder continuar.
            </div>

            <div class="alert alert-success border-success" *ngIf="missingLocalities.length === 0">
                <i class="fas fa-check-circle"></i> Todas las localidades del archivo fueron encontradas en el sistema. Ya puede continuar.
            </div>

            <div class="d-flex justify-content-between align-items-center mb-2" *ngIf="missingLocalities.length > 0">
               <span class="small text-muted">Revise o automatice la creación:</span>
               <button mat-raised-button style="background-color: #6f42c1; color: white;" (click)="massCreateLocalities()">
                 <i class="fas fa-magic mr-2"></i> Crear Todas Automáticamente
               </button>
            </div>

            <div class="table-responsive" *ngIf="missingLocalities.length > 0">
              <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Localidad en Excel</th>
                      <th>Provincia en Excel</th>
                      <th>Cód. Postal</th>
                      <th>Farmacia de Referencia</th>
                      <th style="min-width:150px; text-align: center;">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let m of missingLocalities">
                      <td class="align-middle text-primary"><strong>{{ m.localidad }}</strong></td>
                      <td class="align-middle">{{ m.provincia }}</td>
                      <td class="align-middle">{{ m.codigoPostal }}</td>
                      <td class="align-middle small text-muted">{{ m.farmaciaDemo }}</td>
                      <td class="align-middle text-center">
                          <button mat-stroked-button color="primary" (click)="createNewLocality(m.localidad)">
                            <i class="fas fa-plus"></i> Crear Localidad
                          </button>
                      </td>
                    </tr>
                  </tbody>
              </table>
            </div>

            <div class="d-flex justify-content-end mt-4">
               <button mat-button matStepperPrevious class="mr-2">Atrás</button>
               <button mat-raised-button color="primary"
                      (click)="nextToGeolocationFarmacias()">
                      Continuar a Geolocalización
               </button>
            </div>
        </div>
      </mat-step>

      <mat-step *ngIf="tipoImportacion === 'FARMACIAS'">
        <ng-template matStepLabel>Resultado y Geolocalización</ng-template>

        <div class="mt-4" *ngIf="pharmacyImportResult">
          <!-- 📊 RESUMEN DE PROCESAMIENTO -->
          <div class="alert alert-success border-success shadow-sm mb-4">
            <div class="d-flex align-items-center">
              <i class="fas fa-check-circle fa-2x mr-3 text-success"></i>
              <div>
                <h5 class="alert-heading mb-1 font-weight-bold">¡Importación Completada!</h5>
                <p class="mb-1">Se han procesado <b>{{ pharmacyImportResult.count || 0 }}</b> farmacias del archivo.</p>
                <p class="mb-0 small text-muted font-weight-bold">
                  Gerenciadora: {{ selectedPharmacyGerenciadoraName }} <span class="mx-2">|</span> Archivo: {{ pharmacyFile?.name }}
                </p>
              </div>
            </div>
          </div>

          <!-- BOTÓN DISPARADOR GEOLOCALIZACIÓN (Petición Usuario) -->
          <div class="card p-4 border-primary bg-light-primary text-center mb-4 shadow-sm hvr-shadow" *ngIf="!pharmacyImportResult.totalRecords">
              <h5 class="text-primary font-weight-bold"><i class="fas fa-globe-americas mr-2"></i> Paso 2: Geolocalización</h5>
              <p class="mb-3">El archivo se importó con éxito. Pulse el botón para comenzar a buscar las coordenadas de las farmacias.</p>
              <button mat-raised-button color="primary" class="btn-lg px-5 font-weight-bold" (click)="startGeolocationFarmacias()">
                 <i class="fas fa-map-marker-alt mr-2"></i> Comenzar Geolocalización
              </button>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="card p-3 border-0 bg-light shadow-sm h-100">
                <h6 class="font-weight-bold text-dark border-bottom pb-2 mb-3">
                  <i class="fas fa-chart-pie text-primary mr-2"></i> Estadísticas de Ubicación
                </h6>
                <p class="mb-2"><i class="fas fa-map-marker-alt text-success mr-2"></i> Geolocalizadas: <b>{{ pharmacyImportResult.geolocatedCenters }}</b></p>
                <p class="mb-0 text-danger"><i class="fas fa-search-location mr-2"></i> Sin coordenadas: <b>{{ pharmacyImportResult.unmatchedCenters }}</b></p>

                <div class="mt-4 alert alert-info p-2 small mb-0">
                  <i class="fas fa-info-circle mr-1"></i> Los registros sin coordenadas se crearán con ubicación (0, 0) y podrán ser corregidos luego.
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card p-3 border-0 bg-white shadow-sm border h-100">
                <h6 class="font-weight-bold text-dark border-bottom pb-2 mb-3">
                  <i class="fas fa-hospital-user text-success mr-2"></i> Consolidación de Centros
                </h6>
                <p class="small text-muted mb-3">
                  El sistema agrupará farmacias que compartan la misma dirección en un único Local Médico.
                </p>
                <div class="p-2 border rounded bg-light text-center">
                  <span class="small text-muted d-block">Total de Locales a Crear:</span>
                  <h3 class="font-weight-bold text-primary mb-0">{{ pharmacyImportResult.totalCenters }}</h3>
                </div>
              </div>
            </div>
          </div>

          <!-- PROGRESO DE MIGRACIÓN -->
          <div *ngIf="isMigratingData" class="mt-4 bg-white p-3 border rounded shadow-sm">
            <label class="d-block mb-2 text-success font-weight-bold">
              <i class="fas fa-spinner fa-spin mr-2"></i>
              Migrando Farmacias a Centros: <b>{{geoCurrentCount}} / {{geoInitialCount}}</b>
            </label>
            <mat-progress-bar mode="determinate" [value]="geoProgress" color="accent" style="height: 10px; border-radius: 5px;"></mat-progress-bar>
            <p class="small text-muted mt-2 mb-0">Generando fichas maestras y normalizando teléfonos...</p>
          </div>

          <div class="d-flex justify-content-end mt-5" *ngIf="!isMigratingData && !migrationFinished">
            <button mat-button matStepperPrevious class="mr-2">Atrás</button>
            <button mat-raised-button color="success" (click)="migratePharmaciesToCentros()" class="btn-lg px-4 hvr-grow" [disabled]="!pharmacyImportResult.totalRecords">
              <i class="fas fa-plus-circle mr-2"></i> Confirmar y Crear Centros Médicos
            </button>
          </div>

          <!-- ACORDEON DE REPORTES FINALES -->
          <mat-accordion class="mt-4 animated fadeIn d-block" *ngIf="migrationFinished && (createdProvincesSummary.length > 0 || createdLocalitiesSummary.length > 0 || pharmacyMigrationFailures.length > 0 || failedLocalitiesSummary.length > 0 || createdPharmaciesSummary.length > 0)">

            <!-- PANEL 0: FARMACIAS CREADAS -->
            <mat-expansion-panel class="mb-3" *ngIf="createdPharmaciesSummary.length > 0" style="border-left: 4px solid #28a745;">
              <mat-expansion-panel-header class="bg-light">
                <mat-panel-title class="font-weight-bold text-success">
                  <i class="fas fa-check-circle mr-2 mt-1"></i> Farmacias Creadas con Éxito ({{createdPharmaciesSummary.length}})
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="table-responsive mt-3" style="max-height: 400px; overflow-y: auto;">
                <table class="table table-sm table-hover table-striped mb-0 border">
                  <thead class="bg-light sticky-top">
                    <tr>
                      <th class="py-2 pl-3">Farmacia / Centro Médico</th>
                      <th class="py-2">Provincia</th>
                      <th class="py-2">Localidad</th>
                      <th class="py-2 pr-3">Zona Asignada</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let ph of createdPharmaciesSummary">
                      <td class="pl-3 align-middle font-weight-bold text-dark">{{ ph.nombre }}</td>
                      <td class="align-middle small text-muted">{{ ph.provincia }}</td>
                      <td class="align-middle small text-muted">{{ ph.localidad }}</td>
                      <td class="pr-3 align-middle text-muted">{{ ph.zona }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </mat-expansion-panel>

            <!-- PANEL 1: ENTIDADES CREADAS -->
            <mat-expansion-panel class="mb-3" *ngIf="createdProvincesSummary.length > 0 || createdLocalitiesSummary.length > 0" style="border-left: 4px solid #17a2b8;">
              <mat-expansion-panel-header class="bg-light">
                <mat-panel-title class="font-weight-bold text-info">
                  <i class="fas fa-info-circle mr-2 mt-1"></i> Entidades Creadas/Asociadas en el Proceso
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="row pt-3">
                <div class="col-md-6" *ngIf="createdProvincesSummary.length > 0">
                  <h6 class="font-weight-bold text-dark"><i class="fas fa-map mr-1"></i> Provincias</h6>
                  <ul class="list-group list-group-sm list-group-flush border mb-3">
                    <li class="list-group-item small py-1" *ngFor="let prov of createdProvincesSummary">{{ prov }}</li>
                  </ul>
                </div>
                <div class="col-md-6" *ngIf="createdLocalitiesSummary.length > 0">
                  <h6 class="font-weight-bold text-dark"><i class="fas fa-map-marker-alt mr-1"></i> Localidades Creadas</h6>
                  <ul class="list-group list-group-sm list-group-flush border">
                    <li class="list-group-item small py-1" *ngFor="let loc of createdLocalitiesSummary">{{ loc }}</li>
                  </ul>
                </div>
              </div>
            </mat-expansion-panel>

            <!-- PANEL 2: ERRORES DE MIGRACIÓN -->
            <mat-expansion-panel class="mb-3" *ngIf="pharmacyMigrationFailures.length > 0" style="border-left: 4px solid #dc3545;">
              <mat-expansion-panel-header class="bg-light">
                <mat-panel-title class="font-weight-bold text-danger">
                  <i class="fas fa-exclamation-triangle mr-2 mt-1"></i> Errores de Migración ({{pharmacyMigrationFailures.length}})
                </mat-panel-title>
                <mat-panel-description class="text-danger">
                  Farmacias no importadas
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div class="table-responsive mt-3" style="max-height: 400px; overflow-y: auto;">
                <table class="table table-sm table-hover table-striped mb-0 border">
                  <thead class="bg-light sticky-top">
                    <tr>
                      <th class="py-2 pl-3">Farmacia / Local</th>
                      <th class="py-2">Domicilio</th>
                      <th class="py-2">Provincia (Excel)</th>
                      <th class="py-2">Localidad (Excel)</th>
                      <th class="py-2 pr-3">Motivo del Error</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let fail of pharmacyMigrationFailures">
                      <td class="pl-3 align-middle font-weight-bold text-dark">{{ fail.farmacia }}</td>
                      <td class="align-middle small">{{ fail.domicilio }}</td>
                      <td class="align-middle small text-muted">{{ fail.provincia }}</td>
                      <td class="align-middle small text-muted">{{ fail.localidad }}</td>
                      <td class="pr-3 align-middle text-danger small font-weight-bold">{{ fail.error }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="alert alert-light border mt-3 mb-0 small text-muted">
                <i class="fas fa-info-circle mr-1"></i>
                <b>Nota:</b> Los errores de "Falta Mapeo" indican que la localidad escrita en el Excel no coincide con ninguna localidad activa en el sistema Signo.
              </div>
            </mat-expansion-panel>

            <!-- PANEL 3: LOCALIDADES A CARGAR -->
            <mat-expansion-panel class="mb-3" *ngIf="failedLocalitiesSummary.length > 0" style="border-left: 4px solid #ffc107;">
              <mat-expansion-panel-header class="bg-light">
                <mat-panel-title class="font-weight-bold text-dark">
                  <i class="fas fa-map-marked-alt text-warning mr-2 mt-1"></i> Localidades a Cargar en Signo
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="pt-3">
                <p class="small text-muted mb-3">Estas localidades se encuentran en el Excel pero <b>no existen</b> en el sistema Signo Médico. Debe darlas de alta para que el proceso las reconozca automáticamente.</p>
                <div class="d-flex flex-wrap">
                  <span *ngFor="let loc of failedLocalitiesSummary" class="locality-badge mr-2 mb-2">
                    {{ loc }}
                  </span>
                </div>
              </div>
            </mat-expansion-panel>

          </mat-accordion>

          <!-- BOTÓN FINAL AL FINAL DE TODO (Petición Usuario) -->
          <div class="d-flex justify-content-center mt-5 mb-5" *ngIf="migrationFinished">
              <button mat-raised-button color="primary" class="btn-lg px-5 shadow hvr-grow" (click)="reloadPage()">
                  <i class="fas fa-home mr-2"></i> Finalizar y Volver al Inicio
              </button>
          </div>
        </div>
      </mat-step>

    </mat-horizontal-stepper>
  </mat-card>
</div>
